import { Component, OnInit } from '@angular/core';
import { RequestconfigService } from '../configuration/requestconfig/requestconfig.service';
import { from } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { saveFile, saveAs } from 'file-saver';
import { ModalOptions, BsModalRef, BsModalService } from 'ngx-bootstrap';
import { RecentactivitiesdashboardService } from '../dashboard/recentactivitiesdashboard/recentactivitiesdashboard.service';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-arbitration',
  templateUrl: './arbitration.component.html',
  styleUrls: ['./arbitration.component.css']
})
export class ArbitrationComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Arbitration';
  p: number = 1; public searchText: string;
  itemsPerPage = 20;
  prodformar: any = []; prodformat: string = ''; outputformatstr: string = '';
  outputformatstrarr: any = []; currentRequest: any; branchModalRef: BsModalRef;
  conversionrequest: boolean = true; courtagoopinionrequest = false;
  key: string = 'txtarbitrator3'; //set default
  reverse: boolean = false;
  templist2 = [];
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  };
  researchgrouprequest: boolean = false; informationrequest: boolean = false; internetdownloadrequest: boolean = true;

  tableHeader = [
    { label: '#', key: '', search: '' },
    // {label: 'Action', key: '', search: ''},
    { label: 'Author', key: 'txtarbitrator3', search: '' },
    { label: 'Posted Date', key: 'datedate2', search: '' },
    { label: 'Case Title', key: 'txtcasetitle1', search: '' },
    { label: 'File Name', key: 'filefulltext4', search: '' },
    { label: 'Download', key: '', search: '' }
  ];
  filterShow = false;
  totalRequestCount: number = 0;
  sortCondition = '';
  postedDateRange: any = [];
  searchCondition = '';
  sortDirection = 'asc';

  constructor(private requestConfigService: RequestconfigService, private SpinnerService: NgxSpinnerService, private toastr: ToastrService, private datepipe: DatePipe,
    private router: Router, private modalService: BsModalService, private recentactivityService: RecentactivitiesdashboardService) { }
  arbitrationRequestlist: any = []; reqRelatedyears: year[] = []; selectedyear = []; _dropdownSettings = {}; requestType: number = 1;
  temparbitrationRequestlist: any[] = []
  ngOnInit() {
    // this.getarbitrationdata();
    this.getYear();
    this.getArbitrationData();

    this._dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      defaultOpen: true
      //itemsShowLimit:2,
      //allowSearchFilter: true
    };

    //console.log(this.dropdownList);
  }

  // getarbitrationdata() {
  //   this.SpinnerService.show();
  //   this.requestConfigService.GetRequestType().subscribe(res => {
  //     this.arbitrationRequestlist = res;
  //     this.arbitrationRequestlist = JSON.parse(this.arbitrationRequestlist[0].j)
  //     this.temparbitrationRequestlist = this.arbitrationRequestlist;
  //     // var a = this.datepipe.transform(this.arbitrationRequestlist[0].createdon, "yyyy");
  //     var i = 1;
  //     this.arbitrationRequestlist.forEach((obj, ind) => {

  //       if (obj.datedate2) {
  //         let year = this.datepipe.transform(obj.datedate2, 'yyyy');

  //         const index = this.reqRelatedyears.findIndex(item => item.item_text === year.toString());

  //         if (index === -1) {
  //           this.reqRelatedyears.push({ item_id: i, item_text: year.toString() });
  //           i++
  //         }
  //         //i = i
  //       }


  //     });
  //     this.SpinnerService.hide();
  //     this.selectedyear = this.reqRelatedyears;

  //     console.log(this.reqRelatedyears);
  //     this.reqRelatedyears = JSON.parse(JSON.stringify(this.reqRelatedyears));
  //     console.log(this.reqRelatedyears)
  //   }, error => {
  //     this.toastr.error('not able to get requestdata');
  //   });

  // }


  getYear() {
    const yearModel = {
      pageno_p: 0,
      itemsperpage_p: 0,
      mode_p: 'getyear',
      sorting_p: null,
      searchcondition_p: null
    };
    this.requestConfigService.GetArbitrationData(yearModel).subscribe(arbitrationYear => {
      let yearsList = JSON.parse(arbitrationYear.body[0].j);
      yearsList.forEach((obj) => {
        if (obj.date_part != null) {
          this.reqRelatedyears.push({ item_id: obj.date_part, item_text: obj.date_part.toString() });
        }
      });
      this.selectedyear = this.reqRelatedyears;
      this.reqRelatedyears = JSON.parse(JSON.stringify(this.reqRelatedyears));
    });
  }


  getArbitrationData() {
    
    this.SpinnerService.show();
    const countModel = {
      pageno_p: 0,
      itemsperpage_p: 0,
      mode_p: 'getcount',
      sorting_p: null,
      searchcondition_p: this.searchCondition == '' ? null : this.searchCondition
    };
    this.requestConfigService.GetArbitrationData(countModel).subscribe(arbitrationCount => {
      let count = JSON.parse(arbitrationCount.body[0].j);
      if (arbitrationCount != undefined && arbitrationCount != null && count[0].count != undefined && count[0].count != null) {
        this.totalRequestCount = count[0].count;
        console.log('this.totalRequestCount: ', this.totalRequestCount);
        if (this.totalRequestCount > 0) {
          const getModel = {
            pageno_p: this.p,
            itemsperpage_p: parseInt(this.itemsPerPage.toString(), 10),
            mode_p: 'getall',
            sorting_p: this.sortCondition == '' ? null : this.sortCondition,
            searchcondition_p: this.searchCondition == '' ? null : this.searchCondition
          };
          this.requestConfigService.GetArbitrationData(getModel).subscribe(arbitrationData => {
            this.temparbitrationRequestlist = [];
            this.arbitrationRequestlist = arbitrationData.body;
            if (JSON.parse(this.arbitrationRequestlist[0].j) != null && this.arbitrationRequestlist[0].j.length > 0) {
              this.arbitrationRequestlist = JSON.parse(this.arbitrationRequestlist[0].j);
              this.temparbitrationRequestlist = this.arbitrationRequestlist;
            }
            this.SpinnerService.hide();
          }, error => {
            this.toastr.error('Not able to get Arbitration Data');
            this.SpinnerService.hide();
          });
        } else {
          this.temparbitrationRequestlist = [];
          this.SpinnerService.hide();
        }
      } else {
        this.temparbitrationRequestlist = [];
        this.SpinnerService.hide();
      }
    }, error => {
      this.toastr.error('Not able to get Arbitration Data');
      this.SpinnerService.hide();
    });
  }

  onItemSelect(data) {
    //console.log(event);
    // this.temparbitrationRequestlist = [];
    // let existItem = this.selectedyear.filter(item => item.item_text === data.item_text);
    // if (existItem.length === 0) {
    //   this.selectedyear.push(data)
    // }
    // this.arbitrationRequestlist.forEach((obj, ind) => {
    //   var reqyear = this.datepipe.transform(obj.datedate2, 'yyyy');
    //   this.selectedyear.forEach((yearobj, yindx) => {

    //     var selyear = yearobj.item_text
    //     if (reqyear == selyear) {
    //       this.temparbitrationRequestlist.push(obj);
    //     }
    //   });


    // });
    this.removeCodn();
    this.setSearchCondition();


  }

  onItemSelectAll(data) {

    this.removeCodn();
    this.selectedyear = data;
    // this.temparbitrationRequestlist = this.arbitrationRequestlist;
    this.setSearchCondition();
  }

  onItemDeSelectAll(event) {

    //this.reqRelatedyears = [];
    // this.temparbitrationRequestlist = [];
    this.removeCodn();
    this.selectedyear = [];
    this.setSearchCondition();
  }

  onItemDeSelect(data) {

    //this.templist2 = this.temparbitrationRequestlist;

    // this.temparbitrationRequestlist = this.temparbitrationRequestlist.filter(item => this.datepipe.transform(item.datedate2, 'yyyy') != data.item_text);
    this.removeCodn();
    this.setSearchCondition();



  }

  sort(key) {
    var sortDirection = '';
    if (this.key != key) {
      this.sortDirection = 'asc';
    }
    else {
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.key = key;
    this.reverse = this.sortDirection === 'desc';
    this.sortCondition = '';

    if (key == 'datedate2') {
      this.sortCondition = 'cast(c.' + this.key.toLowerCase() + ' as date)' + ' ' + this.sortDirection;
    }
    else {
      this.sortCondition = 'c.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    }



    // this.sortCondition = 'c.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    this.setSearchCondition();





  }

  viewRequest(request, template) {
    this.currentRequest = request

    //this.getRequestDetails(request)
    this.branchModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");


  }

  fileDownload(request) {
    this.SpinnerService.show();

    let fileData: any = [];
    fileData.push({
      'documentId': request.documentid, 'dbName': 'Case Law', 'formConfigId': request.formconfigid, 'fileName': request.filefulltext4
    })
    this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      saveAs(objectURL, request.filefulltext4);
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });
    // var s = this.databases.filter(e => e.databaseid ==58)
    //  if (s != undefined && s != null && s.length != 0) {


    //this.requestConfigService.DownloadFile(request.documentid, 'Case Law', request.formconfigid, request.filefulltext4).subscribe(res => {
    //    var content = res.file;
    //    let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //    saveAs(objectURL, request.filefulltext4);
    //  });


    //  }
  }

  fileDownloadrequest(request, type) {
    this.SpinnerService.show();
    //added from this line
    var requestid = 0;
    if (request.requesttypeid == 1)
      requestid = request.courtagoopinionrequestid;
    else if (request.requesttypeid == 2)
      requestid = request.researchgrouprequestid;
    else if (request.requesttypeid == 3)
      requestid = request.informationrequestid;
    else if (request.requesttypeid == 4)
      requestid = request.internetdownloadrequestid;
    else
      requestid = request.conversionrequestid;
    //added ends here

    let requestData: any = [];
    requestData.push({
      'requesttype': request.requesttype, 'dbname': request.database, 'requestid': requestid, 'fileName': request.finalupload
    })

    this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
      var content = res.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.file;
      saveAs(objectURL, request.finalupload);
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });

    //this.requestConfigService.DownloadFileRequest(request.database, request.requesttype, request.courtagoopinionrequestid, type, request.finalupload).subscribe(res => {
    //  var content = res.file;
    //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //  saveAs(objectURL, request.finalupload);
    //});
  }

  keypress(event) {
    
    if (event == 13) {
      this.p = 1;
      this.setSearchCondition();
    }
  }


  changeitemsperpage(eve) {
    this.itemsPerPage = eve.currentTarget.value;
    this.removeCodn();
    this.setSearchCondition();
  }

  postDateChange(eve, key) {
    

    this.tableHeader.forEach(element => {
      if (element.key == key) {
        if (eve != null && eve.length > 0) {
          element.search = eve;
        } else {
          element.search = '';
        }
      }
    });
    this.setSearchCondition();
  }

  setSearchCondition() {
    console.log(this.tableHeader);
    let searchCondition = '';
    this.tableHeader.forEach(element => {
      if (element.key != '') {
        if (element.key != 'datedate2') {
          if (searchCondition == '' && element.search != '' && element.search != null) {
            searchCondition = ' and lower(c.' + element.key + ') like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          } else if (element.search != '' && element.search != null) {
            // tslint:disable-next-line: max-line-length
            searchCondition = searchCondition + ' and ' + 'lower(c.' + element.key + ') like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }
        } else if (element.key == 'datedate2') {
          console.log('datedate2', element.search);
          if (searchCondition == '' && element.search != '' && element.search != null) {
            searchCondition = ' and cast(c.' + element.key + ' as date)' + ' between "' + this.datepipe.transform(new Date(element.search[0]), 'MM/dd/yyyy') + '"' + ' and ' + '"' + this.datepipe.transform(new Date(element.search[1]), 'MM/dd/yyyy') + '"';
          }
          else if (element.search != '' && element.search != null) {
            searchCondition = searchCondition + ' and cast(c.' + element.key + ' as date)' + ' between "' + this.datepipe.transform(new Date(element.search[0]), 'MM/dd/yyyy') + '"' + ' and ' + '"' + this.datepipe.transform(new Date(element.search[1]), 'MM/dd/yyyy') + '"';
          }
        }
      }
    });
    if (this.selectedyear.length > 0) {
      let selectYr = [];
      this.selectedyear.forEach(element => {
        selectYr.push(element.item_text);
      });
      if (searchCondition == '') {
        searchCondition = ' and DATE_PART("year", CAST(datedate2 AS DATE)) IN (' + selectYr.join() + ')';
      } else if (searchCondition != '') {
        searchCondition = searchCondition + ' and (DATE_PART("year", CAST(datedate2 AS DATE)) IN (' + selectYr.join() + ') or datedate2 is null)';
      }
    } else {
      searchCondition = ' and (DATE_PART("year", CAST(datedate2 AS DATE)) IN (0) or datedate2 is null)';
    }
    this.searchCondition = searchCondition;
    this.getArbitrationData();
  }


  removeSearchCondition() {
    this.removeCodn();
    this.getArbitrationData();
  }

  removeCodn() {
    let searchCondition = '';
    if (this.selectedyear.length > 0) {
      let selectYr = [];
      this.selectedyear.forEach(element => {
        selectYr.push(element.item_text);
      });
      if (searchCondition == '') {
        searchCondition = ' and DATE_PART("year", CAST(datedate2 AS DATE)) IN (' + selectYr.join() + ')';
      } else if (searchCondition != '') {
        searchCondition = searchCondition + ' and (DATE_PART("year", CAST(datedate2 AS DATE)) IN (' + selectYr.join() + ') or datedate2 is null)';
      }
    } else {
      searchCondition = ' and (DATE_PART("year", CAST(datedate2 AS DATE)) IN (0) or datedate2 is null)';
    }
    this.searchCondition = searchCondition;
    this.tableHeader.forEach(element => {
      element.search = '';
    });
    this.p = 1;
    this.sortCondition = '';
    this.sortDirection = 'asc';
    this.filterShow = false;
    this.reverse = false;
  }


}



export class year {
  item_id: number;
  item_text: string

}
